import { ProductGallery } from "./ProductGallery";
export default ProductGallery;
